export default "__VITE_ASSET__769a346c__"